import { render, staticRenderFns } from "./PartNote.vue?vue&type=template&id=fd0dbce4&scoped=true&"
import script from "./PartNote.vue?vue&type=script&lang=js&"
export * from "./PartNote.vue?vue&type=script&lang=js&"
import style0 from "./PartNote.vue?vue&type=style&index=0&id=fd0dbce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0dbce4",
  null
  
)

export default component.exports